import type { ButtonProps } from "@/ui/core/buttons/Button";
import Button from "@/ui/core/buttons/Button";
import type { FloatingButtonWrapperProps } from "@/ui/core/buttons/FloatingButtonWrapper";
import FloatingButtonWrapper from "@/ui/core/buttons/FloatingButtonWrapper";
import { joinTestIDs } from "@/utils/string.util";

type BaseButtonProps = Omit<ButtonProps, "size" | "variant">;

interface FloatingButtonProps
  extends BaseButtonProps, FloatingButtonWrapperProps {}

const FloatingButton = ({
  accessibilityLabel,
  isDisabled,
  isLoading,
  leftIcon,
  onPress,
  opacity,
  paddingBottom,
  rightIcon,
  testID,
  title,
}: FloatingButtonProps) => {
  return (
    <FloatingButtonWrapper opacity={opacity} paddingBottom={paddingBottom}>
      <Button
        accessibilityLabel={`${accessibilityLabel} Floating Button`}
        isDisabled={isDisabled}
        isFAB
        isLoading={isLoading}
        leftIcon={leftIcon}
        onPress={onPress}
        rightIcon={rightIcon}
        size="normal"
        testID={joinTestIDs(testID, "floating")}
        title={title}
        variant="primary"
      />
    </FloatingButtonWrapper>
  );
};

export default FloatingButton;
